<template>
    <div>
        <Layout>
            <PageHeader :title="title" :items="items" />
            <div class="row" v-if="$store.getters['wallet/validWallet']">
                <div
                    class="col-xl-3 col-sm-6"
                    v-for="(item, index) in gridList"
                    :key="index"
                >
                    <div class="card text-center">
                    <div class="card-body">
                        <div class="clearfix"></div>
                        <div class="mb-4">
                            <br/>
                        <img
                            v-if="item.profile"
                            :src="item.profile"
                            alt
                            class="avatar-lg rounded-circle img-thumbnail"
                        />
                        <div class="avatar-lg mx-auto mb-4" v-if="!item.profile">
                            <div
                            class="avatar-title bg-soft-primary rounded-circle text-primary"
                            >
                            <i
                                class="mdi mdi-account-circle display-4 m-0 text-primary"
                            ></i>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="btn-group" role="group">
                        <button type="button" class="btn btn-outline-light text-truncate" @click="checkHands">
                        <i class="fas fa-play-circle"></i> Check Hands
                        </button>
                    </div>
                    </div>
                </div>
                </div>
                <!-- end row -->
            <div class="row" v-else>
                <div class="col-12 col-md-12 col-lg-8 col-xl-5">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="card-title">FatCake Rewards Tracking</h4>
                            <p class="card-title-desc">
                            Easily rewards checking
                            FatCake Tracking App
                            FatCake's chart, price movements, market cap, volume and more for all. Track Frictionless Rewards of FatCake and it's value in USD.
                            </p>

                            <div class="">
                                <b-alert variant="danger" show>Not connected to any wallet!</b-alert
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </div>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
const Web3 = require('web3');

export default {
    page: {
        title: "Diamond Hands",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
    },
    methods: {
        checkHands: async function() {
            let client = new Web3("https://bsc-dataseed.binance.org");
            let contractCreatedBlock = 9442443;
            let currentBlock = await client.eth.getBlockNumber();

            console.log(`Created Block: ${contractCreatedBlock}`);
            console.log(`Current Block: ${currentBlock}`);
            console.log(`Blocks to check: ${currentBlock - contractCreatedBlock}`);

            // for (let i = currentBlock; i > contractCreatedBlock; i--) {
            //     let block = await client.eth.getBlock(i, true);
            //     console.log(i);

            //     let transactions = block.transactions;
            //     for (let t = 0; t < transactions.length; t++) {
            //         if (transactions[t].from == "0xf3aEc0471336bcd7b4532C32d9435697f5D7073F") {
            //             console.log("Yes, etwas gefunden :)");
            //         }
            //     }
            // }
            
        },
    },
    data: function() {
        return {
            title: "Diamond Hands",
            items: [
                {
                    text: "FatCake",
                    active: true,
                },
                {
                    text: "Diamond Hands",
                },
            ],
            gridList: [
                {
                profile: "https://upload.wikimedia.org/wikipedia/commons/4/43/Diamond_Icon_White.png",
                name: "Simon Ryles",
                designation: "Full Stack Developer",
                }
            ],
        };
    }
}
</script>